module.exports = __webpack_public_path__ + "img/logoarticle19.deb6916c.png";